import styled from 'styled-components';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import Button from '../../../../components/Button';
import { Col } from '../../../../components/v2/Grid';
import colors from '../../../../styles/colors';

const StyledListElement = styled.li`
  margin-bottom: 20px;
  display: flex;
  border-radius: 8px;
  border: 1px solid ${colors.shades.gamma1};
  padding: 16px 20px;
`;

const StyledButton = styled(Button)`
  font-weight: 600;
  font-size: 14px;
  border-radius: 6px;
  height: 36px;
  cursor: pointer;
`;

const StyledLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

const StyledStatus = styled.span`
  font-size: 12px;
  color: ${colors.shades.gamma2};
  font-weight: 500;
  border: 1px solid ${colors.shades.gamma1};
  border-radius: 4px;
  padding: 2px 8px;
  margin-left: 8px;
  background: ${colors.shades.alpha2};
  line-height: 16px;
`;

const StyledDescription = styled.div`
  font-size: 13px;
  color: ${colors.shades.gamma2};
  margin-top: 2px;
  margin-bottom: 0;
  line-height: 18px;
`;

const StyledTime = styled.span`
  font-size: 12px;
  color: ${colors.shades.gamma2};
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StyledAccessTimeIcon = styled(AccessTimeIcon)`
  width: 16px;
  height: 16px;
`;

const TimeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StyledCol = styled(Col)`
  gap: 8px;
  flex: 1;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  margin-left: 2%;
`;

export {
  StyledButton,
  StyledListElement,
  StyledLabel,
  StyledStatus,
  StyledDescription,
  StyledTime,
  StyledAccessTimeIcon,
  TimeRow,
  StyledCol,
  StyledButtonContainer,
};
